import React from 'react';
import { Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Navigate, useLocation } from 'react-router-dom';

import Meta from '@bizapp-lp/workflow/organisms/Meta';
import Complete from '@bizapp-lp/workflow/templates/Complete';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    lineBreaks: {
      display: 'block',
    },
  }),
);

type CompleteContactState = {
  valid?: boolean;
};

export interface CompleteContactProps {
  isAllowedDirectAccess?: boolean;
}
const title =
  'Workflow お問い合わせ | ノーコードで現場で簡単に利用することができるワークフローサービス';
const description =
  '株式会社ワークスアプリケーションズ・エンタープライズがご提供する、Workflow お問い合わせ完了ページです。';

const CompleteContact: React.FC<CompleteContactProps> = ({
  isAllowedDirectAccess,
}) => {
  const classes = useStyle();
  const { state } = useLocation() as { state: CompleteContactState };
  return isAllowedDirectAccess || state?.valid ? (
    <>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <Complete
        heading1="お問い合わせ"
        heading2="お問い合わせが完了しました"
        description={
          <>
            <span className={classes.lineBreaks}>
              お問い合わせいただき、ありがとうございました。{' '}
            </span>
            <span className={classes.lineBreaks}>
              確認のためお客様へ自動返信メールをお送りしております。
            </span>
            <span className={classes.lineBreaks}>
              弊社担当よりご連絡いたしますので、今しばらくお待ちください。
            </span>
          </>
        }
      />
    </>
  ) : (
    <Navigate to="/workflow/invalid" replace />
  );
};

export default CompleteContact;
